import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from '../styles/style.module.css';

export default class PurpleLogoIcon extends PureComponent {
    render() {
        var inlineStyle = { ...this.props.style };
        if( this.props.size !== undefined ) {
            inlineStyle.width = inlineStyle.height = this.props.size + 'px';
        }
        return (
            <div className={ `${ style.purpleLogoIcon } ${ this.props.className }` } style={ inlineStyle }></div>
        );
    }
}

PurpleLogoIcon.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
};
PurpleLogoIcon.defaultPropTypes = {
    className: '',
};
